export default {
  // 等待
  WAIT: 'WAIT',
  // 正在进行
  RUN: 'RUN',
  // 中断
  INTERRUPT: 'INTERRUPT',
  // 等待机修
  MACHINE_REPAIR_WAIT: 'MACHINE_REPAIR_WAIT',
  // 正在机修
  MACHINE_REPAIR_RUN: 'MACHINE_REPAIR_RUN'
}
